module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/376.392bced1.png";